import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const History = () => {
    
    const { sessionId } = useParams();
    const [session, setSession] = useState(null);

    const userName = localStorage.getItem("username");

    useEffect(() => {
        const fetchSession = async () => {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/session/${sessionId}`); 
            setSession(res.data);
        };

        fetchSession();
    }, [sessionId]);

    if(!session) return <p> Loading... </p>;

    return (
        <div>
            <header className="flex justify-between items-center px-6 py-4 bg-gray-900 text-white shadow-md"> 
                <h1 className="text-2xl font-bold cursor-pointer"> History </h1>

                <h1> {userName} </h1>
            </header>

            <div className="p-5">
                <h2 className="text-2xl font-bold mb-5">
                    {session.role} ({session.experience} years)
                </h2>

                {session.questions.map((q, i) => (
                    <div key={i} className="p-4 border rounded mb-3">
                        <p> <b> Q: </b> {q.question} </p>
                        <p> <b> A: </b> {q.answer} </p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default History;